import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'
import { typeMapWithIds } from '@/api/Intel/utils'

export const useGetTTPsDownload = (type, options = {}) => {
  if (!type) {
    throw new Error('useGetTTPsDownload requires a type')
  }

  const api = useMatiApiClient('ttps')
  const { ids, ...restOptions } = options

  if (ids && !Array.isArray(ids)) {
    throw new Error('ids option must be an array')
  }

  const enabled = !!type && !!ids?.length

  return useQuery({
    queryFn: () => api.download(typeMapWithIds(type, ids)),
    queryKey: ['ttps download', type, ids],
    ...restOptions,
    enabled: (restOptions.enabled ?? true) && enabled
  })
}
